import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'number-17-small', 'IconNumber17Small', [["path",{"d":"M7 10l2 -2v8","key":"svg-0"}],["path",{"d":"M13 8h4l-2 8","key":"svg-1"}]]);